export default {
      id: "format-quote-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#format-quote-usage",
      toString: function () {
        return this.url;
      }
    }